import { useEffect, useState } from "react";
import axios from "../../../axios";
import { Link, useNavigate } from "react-router-dom";

export default function SizeListPage() {
    const [sizes, setSizes] = useState([]);
    const navigate = useNavigate();


    useEffect(() => {
        axios.get("/admin/sizes").then(res => setSizes(res.data));
    }, []);

    const handleDelete = async (id) => {
        if (!window.confirm("Yakin ingin menghapus ukuran ini?")) return;
        try {
            await axios.delete(`/admin/sizes/${id}`);
            setSizes(sizes.filter((s) => s.id !== id));
        } catch (err) {
            alert("Gagal menghapus data");
        }
    };

    return (
        <div className="card mt-24">
            <div className="card-header border-bottom">
                <h4 className="mb-4">Daftar Ukuran</h4>
            </div>

            <div className="card-body">
                <Link to="/admin/sizes/create">
                    <button className="btn btn-main">+ Tambah Ukuran</button>
                </Link>
                <table className="table table-lg table-striped w-100">
                    <thead>
                        <tr>
                            <th className="h6 text-gray-600 text-center">Type</th>
                            <th className="h6 text-gray-600 text-center">Size</th>
                            <th className="h6 text-gray-600 text-center"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {sizes.map(size => (
                            <tr
                                key={size.id}
                                // onClick={() => navigate(`/admin/sizes/${size.id}`)}
                                style={{ cursor: "pointer" }}
                                onMouseOver={(e) => e.currentTarget.style.background = "#f0f0f0"}
                                onMouseOut={(e) => e.currentTarget.style.background = "transparent"}
                            >
                                <td className="text-center">
                                    <span className="text-gray-600">{size.type}</span>
                                </td>
                                <td className="text-center">
                                    <span className="text-gray-600"><span style={{ marginRight: 10 }}>{size.width} x {size.height}</span>
                                        <span className="pr-3" style={{ borderWidth: 1, borderStyle: 'solid', width: `${size.width}px`, height: `${size.height}px` }}>&nbsp;</span>
                                    </span>
                                </td>
                                <td>
                                    <span className="text-gray-600" >
                                        <button className="btn btn-warning mt-4" onClick={() => navigate(`/admin/sizes/${size.id}/edit`)}>Edit</button>
                                        <button className="btn btn-danger mt-4" onClick={() => handleDelete(size.id)} style={{ marginLeft: "0.5rem", backgroundColor: "red", color: "white" }}>
                                            Hapus
                                        </button>
                                    </span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
